import type { AuditLogEvent } from 'types/entities';

import { T } from '@app/components/translation';

type Props = {
  auditLogEvent: AuditLogEvent;
};

export const ExtensionDisableEvent = ({ auditLogEvent }: Props) => (
  <T
    _str='The marketplace item "{extensionName}" was disabled'
    _comment="Audit log event message for disabling an extension"
    extensionName={auditLogEvent.target?.name}
  />
);
